{
  "title": "Cho phép truy cập vị trí của bạn?",
  "body": "Khi cho phép truy cập vị trí, chúng tôi có thể xác nhận rằng bạn đã đến cơ sở để check-in",
  "disagree": "Không đồng ý",
  "agree": "Đồng ý"
}
